var inputDe = $("#gift-note").val();
var inputPara = $("#gift-note1").val();
var inputMensaje = $("#gift-note2").val();


var contentText = $("#gift-note").on("keyup", function() {
  inputDe = $(this).val();
  updateNotas();
});
var contentText = $("#gift-note1").on("keyup", function() {
   inputPara = $(this).val();
  updateNotas();
});
var contentText = $("#gift-note2").on("keyup", function() {
  inputMensaje = $(this).val();
  updateNotas();
});

function updateNotas() {
  $('#CartSpecialInstructions').html('De: ' + inputDe+ ' Para: ' + inputPara + ' Mensaje: ' + inputMensaje);
}
